/**
 * Centralizes the document export for "Emissions" and "Consumptions" into a maintainable utility function.
 * @param {()} dispatch useDispatch() instance
 * @param {()} getAction The get request to initiate the response
 * @param {[number, number, string] | [number, string]} getActionArguments Arguments passed into the get request, i.e. [companyId, groupId, year]
 * @param {string} downloadTitle 
 */
export async function triggerExcelDownload(dispatch, getAction, getActionArguments, downloadTitle) {
    const response = await dispatch(getAction(...getActionArguments))
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', downloadTitle)
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url);
    link.remove();
}